// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

export const getTableSettings = (payload = null) => http.post('apiSystemSettings/getTableSettings', payload).then(getData);

export const get = (payload = null) => http.post('apiSystemSettings/getRows', payload).then(getData);

export const create = (row) => http.post('apiSystemSettings/create', row).then(getData);

export const update = (row) => http.post('apiSystemSettings/edit', row).then(getData);

export const remove = (row) => http.post('apiSystemSettings/delete', row).then(getData);

export const getRow = (row) => http.post(`apiSystemSettings/getRow&RowID=${row}`).then(getData);